// extracted by css-extract-rspack-plugin
export default {"rules":"rules-pz1Q7b","summary":"summary-WkvIy4","body":"body-P44nLo"};